// Auth
export const LOGIN = {
	LOGIN: '@LOGIN/LOGIN',
	SUCCESS: '@LOGIN/SUCCESS',
	FAIL: '@LOGIN/FAIL',
};
export const LOGOUT = {
	LOGOUT: '@LOGOUT/LOGOUT',
	SUCCESS: '@LOGOUT/SUCCESS',
	FAIL: '@LOGOUT/FAIL',
};

// Init
export const INIT = {
	START: '@INIT/START',
	SUCCESS: '@INIT/SUCCESS',
	FAIL: '@INIT/FAIL',
};

// User
export const SET_ACTIVE_TEAM = 'SET_ACTIVE_TEAM';
export const SET_ACTIVE_ORGANIZATION = 'SET_ACTIVE_ORGANIZATION';

// Loading
export const SET_LOADING = 'SET_LOADING' as const;

// Popup
export const SET_MODAL = 'SET_MODAL';

// Report Story
export const GET_REPORT_STORIES = {
	GET: '@GET_REPORT_STORIES/GET',
	SUCCESS: '@GET_REPORT_STORIES/SUCCESS',
	SUCCESS_PUSH: '@GET_REPORT_STORIES/SUCCESS_PUSH',
	FAIL: '@GET_REPORT_STORIES/FAIL',
};

export const GET_BIG_PICTURE_STORY_REPORT = {
	GET: '@GET_BIG_PICTURE_STORY_REPORT/GET',
	SUCCESS: '@GET_BIG_PICTURE_STORY_REPORT/SUCCESS',
	FAIL: '@GET_BIG_PICTURE_STORY_REPORT/FAIL',
};

export const GET_BY_CARD_STORY_REPORT = {
	GET: '@GET_BY_CARD_STORY_REPORT/GET',
	SUCCESS: '@GET_BY_CARD_STORY_REPORT/SUCCESS',
	FAIL: '@GET_BY_CARD_STORY_REPORT/FAIL',
};

// Story
export const CREATE_STORY = {
	CREATE: '@CREATE_STORY/CREATE',
	SUCCESS: '@CREATE_STORY/SUCCESS',
	FAIL: '@CREATE_STORY/FAIL',
};
export const DUPLICATE_STORY = {
	START: '@DUPLICATE_STORY/START',
	SUCCESS: '@DUPLICATE_STORY/SUCCESS',
	FAIL: '@DUPLICATE_STORY/FAIL',
};
export const DELETE_STORY = {
	START: '@DELETE_STORY/START',
	SUCCESS: '@DELETE_STORY/SUCCESS',
	FAIL: '@DELETE_STORY/FAIL',
};
export const UPDATE_LATEST_STORY = {
	UPDATE: '@UPDATE_LATEST_STORY/UPDATE',
	SUCCESS: '@UPDATE_LATEST_STORY/SUCCESS',
	FAIL: '@UPDATE_LATEST_STORY/FAIL',
};
export const STORY_ROLLBACK = {
	START: '@STORY_ROLLBACK/START',
	SUCCESS: '@STORY_ROLLBACK/SUCCESS',
	FAIL: '@STORY_ROLLBACK/FAIL',
} as const;
export const UPDATE_STORY = {
	UPDATE: '@UPDATE_STORY/UPDATE',
	SUCCESS: '@UPDATE_STORY/SUCCESS',
	FAIL: '@UPDATE_STORY/FAIL',
};
export const UPDATE_PUBLISHED_STORY = {
	UPDATE: '@UPDATE_PUBLISHED_STORY/UPDATE',
	SUCCESS: '@UPDATE_PUBLISHED_STORY/SUCCESS',
	FAIL: '@UPDATE_PUBLISHED_STORY/FAIL',
};
export const UNPUBLISH_PUBLISHED_STORY = {
	START: '@UNPUBLISH_PUBLISHED_STORY/START',
	SUCCESS: '@UNPUBLISH_PUBLISHED_STORY/SUCCESS',
	FAIL: '@UNPUBLISH_PUBLISHED_STORY/FAIL',
};
export const GET_STORIES = {
	GET: '@GET_STORIES/GET',
	SUCCESS: '@GET_STORIES/SUCCESS',
	SUCCESS_PUSH: '@GET_STORIES/SUCCESS_PUSH',
	FAIL: '@GET_STORIES/FAIL',
};
export const GET_STORY = {
	GET: '@GET_STORY/GET',
	SUCCESS: '@GET_STORY/SUCCESS',
	FAIL: '@GET_STORY/FAIL',
};
export const GET_STORY_DICTIONARY = {
	GET: '@GET_STORY_DICTIONARY/GET',
	SUCCESS: '@GET_STORY_DICTIONARY/SUCCESS',
	FAIL: '@GET_STORY_DICTIONARY/FAIL',
};
export const UPDATE_STORY_URL = {
	UPDATE: '@UPDATE_STORY_URL/UPDATE',
	SUCCESS: '@UPDATE_STORY_URL/SUCCESS',
	FAIL: '@UPDATE_STORY_URL/FAIL',
};

export const POST_GALLERY = {
	START: '@POST_GALLERY/START',
	SUCCESS: '@POST_GALLERY/SUCCESS',
	FAIL: '@POST_GALLERY/FAIL',
};

export const UPDATE_STORY_ELEMENTS = 'UPDATE_STORY_ELEMENTS';
export const UPDATE_EDITABLE_STORY = {
	UPDATE: '@UPDATE_EDITABLE_STORY/UPDATE',
};

export const RESET_ANALYTICS = 'RESET_ANALYTICS';
export const GET_STORY_VIEW_STATS = {
	START: '@GET_STORY_VIEW_STATS/START',
	SUCCESS: '@GET_STORY_VIEW_STATS/SUCCESS',
	FAIL: '@GET_STORY_VIEW_STATS/FAIL',
};

export const GET_STORY_CARDS_VIEW_STATS = {
	START: '@GET_STORY_CARDS_VIEW_STATS/START',
	SUCCESS: '@GET_STORY_CARDS_VIEW_STATS/SUCCESS',
	FAIL: '@GET_STORY_CARDS_VIEW_STATS/FAIL',
};

export const GET_STORY_CARDS_ANSWERS_STATS = {
	START: '@GET_STORY_CARDS_ANSWERS_STATS/START',
	SUCCESS: '@GET_STORY_CARDS_ANSWERS_STATS/SUCCESS',
	FAIL: '@GET_STORY_CARDS_ANSWERS_STATS/FAIL',
};
export const GET_STORY_AUDIENCE = {
	START: '@GET_STORY_AUDIENCE/START',
	SUCCESS: '@GET_STORY_AUDIENCE/SUCCESS',
	FAIL: '@GET_STORY_AUDIENCE/FAIL',
};
export const GET_CARD_AUDIENCE = {
	START: '@GET_CARD_AUDIENCE/START',
	SUCCESS: '@GET_CARD_AUDIENCE/SUCCESS',
	FAIL: '@GET_CARD_AUDIENCE/FAIL',
};

// Member:
export const UPDATE_MEMBER_EMAIL = {
	UPDATE: '@UPDATE_MEMBER_EMAIL/UPDATE',
	SUCCESS: '@UPDATE_MEMBER_EMAIL/SUCCESS',
	FAIL: '@UPDATE_MEMBER_EMAIL/FAIL',
};

export const UPDATE_MEMBER_PASSWORD = {
	START: '@UPDATE_MEMBER_PASSWORD/START',
	SUCCESS: '@UPDATE_MEMBER_PASSWORD/SUCCESS',
	FAIL: '@UPDATE_MEMBER_PASSWORD/FAIL',
};

export const GET_MEMBER = {
	GET: '@GET_MEMBER/GET',
	SUCCESS: '@GET_MEMBER/SUCCESS',
	FAIL: '@GET_MEMBER/FAIL',
};

export const GET_MEMBER_STORIES = {
	GET: '@GET_MEMBER_STORIES/GET',
	SUCCESS: '@GET_MEMBER_STORIES/SUCCESS',
	SUCCESS_PUSH: '@GET_MEMBER_STORIES/SUCCESS_PUSH',
	FAIL: '@GET_MEMBER_STORIES/FAIL',
};

export const RESET_PASSWORD = {
	RESET: '@RESET_PASSWORD/RESET',
	SUCCESS: '@RESET_PASSWORD/SUCCESS',
	FAIL: '@RESET_PASSWORD/FAIL',
};

export const RESTORE_PASSWORD = {
	RESTORE: '@RESTORE_PASSWORD/RESTORE',
	SUCCESS: '@RESTORE_PASSWORD/SUCCESS',
	FAIL: '@RESTORE_PASSWORD/FAIL',
};

export const DELETE_MEMBER = {
	START: '@DELETE_MEMBER/START',
	SUCCESS: '@DELETE_MEMBER/SUCCESS',
	FAIL: '@DELETE_MEMBER/FAIL',
};

export const MEMBER_PREFERENCES = {
	GET: '@MEMBER_PREFERENCES/GET',
	SUCCESS: '@MEMBER_PREFERENCES/SUCCESS',
	FAIL: '@MEMBER_PREFERENCES/FAIL',
};

export const UPDATE_MEMBER = {
	START: '@UPDATE_MEMBER/START',
	SUCCESS: '@UPDATE_MEMBER/SUCCESS',
	FAIL: '@UPDATE_MEMBER/FAIL',
};

export const UPDATE_MEMBER_AVATAR = {
	START: '@UPDATE_MEMBER_AVATAR/START',
	SUCCESS: '@UPDATE_MEMBER_AVATAR/SUCCESS',
	FAIL: '@UPDATE_MEMBER_AVATAR/FAIL',
};

export const MEMBER_PREFERENCES_UPDATE = {
	UPDATE: '@MEMBER_PREFERENCES_UPDATE/UPDATE',
	SUCCESS: '@MEMBER_PREFERENCES_UPDATE/SUCCESS',
	FAIL: '@MEMBER_PREFERENCES_UPDATE/FAIL',
};

// Organization:
export const ACCEPT_INVITE_TO_ORGANIZATION = {
	GET: '@ACCEPT_INVITE_TO_ORGANIZATION/START',
	SUCCESS: '@ACCEPT_INVITE_TO_ORGANIZATION/SUCCESS',
	FAIL: '@ACCEPT_INVITE_TO_ORGANIZATION/FAIL',
};

export const UPDATE_ORGANIZATION_MEMBER = {
	UPDATE: '@UPDATE_ORGANIZATION_MEMBER/UPDATE',
	SUCCESS: '@UPDATE_ORGANIZATION_MEMBER/SUCCESS',
	FAIL: '@UPDATE_ORGANIZATION_MEMBER/FAIL',
};

export const REMOVE_MEMBER_FROM_ORGANIZATION = {
	START: '@REMOVE_MEMBER_FROM_ORGANIZATION/START',
	SUCCESS: '@REMOVE_MEMBER_FROM_ORGANIZATION/SUCCESS',
	FAIL: '@REMOVE_MEMBER_FROM_ORGANIZATION/FAIL',
};

export const RESEND_INVITE_TO_ORGANIZATION = {
	START: '@RESEND_INVITE_TO_ORGANIZATION/START',
	SUCCESS: '@RESEND_INVITE_TO_ORGANIZATION/SUCCESS',
	FAIL: '@RESEND_INVITE_TO_ORGANIZATION/FAIL',
};

export const SETUP_INVITE_TO_ORGANIZATION = {
	GET: '@SETUP_INVITE_TO_ORGANIZATION/START',
	SUCCESS: '@SETUP_INVITE_TO_ORGANIZATION/SUCCESS',
	FAIL: '@SETUP_INVITE_TO_ORGANIZATION/FAIL',
};

export const GET_ORGANIZATION_TEAMS_OF_MEMBER = {
	GET: '@GET_ORGANIZATION_TEAMS_OF_MEMBER/GET',
	SUCCESS: '@GET_ORGANIZATION_TEAMS_OF_MEMBER/SUCCESS',
	FAIL: '@GET_ORGANIZATION_TEAMS_OF_MEMBER/FAIL',
};

export const GET_ORGANIZATION_TEAMS = {
	GET: '@GET_ORGANIZATION_TEAMS/GET',
	SUCCESS: '@GET_ORGANIZATION_TEAMS/SUCCESS',
	FAIL: '@GET_ORGANIZATION_TEAMS/FAIL',
};

export const GET_ORGANIZATION_MEMBERS = {
	GET: '@GET_ORGANIZATION_MEMBERS/GET',
	SUCCESS: '@GET_ORGANIZATION_MEMBERS/SUCCESS',
	FAIL: '@GET_ORGANIZATION_MEMBERS/FAIL',
};

export const ADD_MEMBERS_TO_ORGANIZATION_TEAMS = {
	ADD: '@ADD_MEMBERS_TO_ORGANIZATION_TEAMS/ADD',
	SUCCESS: '@ADD_MEMBERS_TO_ORGANIZATION_TEAMS/SUCCESS',
	FAIL: '@ADD_MEMBERS_TO_ORGANIZATION_TEAMS/FAIL',
};

export const VALIDATE_ORGANIZATION_NAME = {
	START: '@VALIDATE_ORGANIZATION_NAME/START',
	SUCCESS: '@VALIDATE_ORGANIZATION_NAME/SUCCESS',
	FAIL: '@VALIDATE_ORGANIZATION_NAME/FAIL',
};

export const UPDATE_ORGANIZATION_SETTINGS = {
	START: '@UPDATE_ORGANIZATION_SETTINGS/START',
	SUCCESS: '@UPDATE_ORGANIZATION_SETTINGS/SUCCESS',
	FAIL: '@UPDATE_ORGANIZATION_SETTINGS/FAIL',
};

// Team:
export const CREATE_TEAM = {
	CREATE: '@CREATE_TEAM/CREATE',
	SUCCESS: '@CREATE_TEAM/SUCCESS',
	FAIL: '@CREATE_TEAM/FAIL',
};
export const GET_TEAM = {
	GET: '@GET_TEAM/GET',
	SUCCESS: '@GET_TEAM/SUCCESS',
	FAIL: '@GET_TEAM/FAIL',
};
export const UPDATE_TEAM = {
	UPDATE: '@UPDATE_TEAM/UPDATE',
	SUCCESS: '@UPDATE_TEAM/SUCCESS',
	FAIL: '@UPDATE_TEAM/FAIL',
};
export const GET_TEAM_STORIES = {
	GET: '@GET_TEAM_STORIES/GET',
	SUCCESS: '@GET_TEAM_STORIES/SUCCESS',
	FAIL: '@GET_TEAM_STORIES/FAIL',
};
export const GET_TEAM_STORIES_OF_MEMBER = {
	GET: '@GET_TEAM_STORIES_OF_MEMBER/GET',
	SUCCESS: '@GET_TEAM_STORIES_OF_MEMBER/SUCCESS',
	SUCCESS_PUSH: '@GET_TEAM_STORIES_OF_MEMBER/SUCCESS_PUSH',
	FAIL: '@GET_TEAM_STORIES_OF_MEMBER/FAIL',
};
export const GET_TEAM_MEMBERS = {
	GET: '@GET_TEAM_MEMBERS/GET',
	SUCCESS: '@GET_TEAM_MEMBERS/SUCCESS',
	FAIL: '@GET_TEAM_MEMBERS/FAIL',
};
export const UPDATE_TEAM_MEMBER = {
	UPDATE: '@UPDATE_TEAM_MEMBER/UPDATE',
	SUCCESS: '@UPDATE_TEAM_MEMBER/SUCCESS',
	FAIL: '@UPDATE_TEAM_MEMBER/FAIL',
};
export const DELETE_TEAM_MEMBER = {
	DELETE: '@DELETE_TEAM_MEMBER/DELETE',
	SUCCESS: '@DELETE_TEAM_MEMBER/SUCCESS',
	FAIL: '@DELETE_TEAM_MEMBER/FAIL',
};
export const DELETE_TEAM = {
	DELETE: '@DELETE_TEAM/DELETE',
	SUCCESS: '@DELETE_TEAM/SUCCESS',
	FAIL: '@DELETE_TEAM/FAIL',
};

// Templates
export const GET_TEMPLATES = {
	START: '@GET_TEMPLATES/START',
	SUCCESS: '@GET_TEMPLATES/SUCCESS',
	FAIL: '@GET_TEMPLATES/FAIL',
};
export const GET_TEMPLATE = {
	START: '@GET_TEMPLATE/START',
	SUCCESS: '@GET_TEMPLATE/SUCCESS',
	FAIL: '@GET_TEMPLATE/FAIL',
};

// Version
export const SET_VERSION = 'SET_VERSION';

// Card Editor
export const SET_EDITABLE_EDITOR_ELEMENT = 'SET_EDITABLE_EDITOR_ELEMENT';
export const SET_EDITABLE_ELEMENT_MODE = 'SET_EDITABLE_ELEMENT_MODE';
export const SET_EDITOR_CURRENT_MEDIA_QUERY = 'SET_EDITOR_CURRENT_MEDIA_QUERY';
export const SET_EDITABLE_STATE = 'SET_EDITABLE_STATE';
export const SET_EDITOR_SIZE = 'SET_EDITOR_SIZE';
export const UPDATE_EDITABLE_CARD_DATA = 'UPDATE_EDITABLE_CARD_DATA';
export const UPDATE_EDITABLE_CARD_IN_STORY = 'UPDATE_EDITABLE_CARD_IN_STORY';
export const RESET_EDITABLE_CARD = 'RESET_EDITABLE_CARD';
export const REMOVE_STORY_FLOAT_REFERENCES = 'REMOVE_STORY_FLOAT_REFERENCES';
export const ADD_STORY_FLOAT_REFERENCES = 'ADD_STORY_FLOAT_REFERENCES';
export const CARD_EDITOR_UNMOUNT_LOADING = 'CARD_EDITOR_UNMOUNT_LOADING';
export const CARD_EDITOR_SYNC = {
	DRAFT: '@CARD_EDITOR_SYNC/DRAFT',
	SYNC: '@CARD_EDITOR_SYNC/SYNC',
	FAIL: '@CARD_EDITOR_SYNC/FAIL',
	SUCCESS: '@CARD_EDITOR_SYNC/SUCCESS',
} as const;
export const STORY_EDITOR_SYNC = {
	DRAFT: '@STORY_EDITOR_SYNC/DRAFT',
	SYNC: '@STORY_EDITOR_SYNC/SYNC',
	FAIL: '@STORY_EDITOR_SYNC/FAIL',
	SUCCESS: '@STORY_EDITOR_SYNC/SUCCESS',
} as const;
export const STORY_EDITOR_UNMOUNT = '@STORY_EDITOR/UNMOUNT';
export const CARD_EDITOR_UNMOUNT = '@CARD_EDITOR/UNMOUNT';
export const APPLY_STORY_VOLUNTARY_UPDATES = {
	START: '@APPLY_STORY_VOLUNTARY_UPDATES/START',
	SUCCESS: '@APPLY_STORY_VOLUNTARY_UPDATES/SUCCESS',
	FAIL: '@APPLY_STORY_VOLUNTARY_UPDATES/FAIL',
};
